import { z } from 'zod'
import { baseStateSchema } from './base'

// -------------------------
// Pub Sidebar State Validation
// -------------------------
export const pubSidebarStateSchema = baseStateSchema.extend({
  isOpen: z.boolean(),
  activeSection: z.string().nullable()
})

export const pubSidebarActionValidation = {
  'pubSidebar/setOpen': z.boolean(),
  'pubSidebar/setActiveSection': z.string().nullable()
} as const

// Type inference helpers
export type PubSidebarStateValidation = z.infer<typeof pubSidebarStateSchema>
